export const exerciseOptions = {
  method: 'GET',
  params: { limit: '10' },
  headers: {
    'X-RapidAPI-Key': '84c63b0a8cmshc209dc026eebf81p1a382cjsn205aa53cd318',
    'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com'
  }
};
export const fetchData = async (url, Option) => {
  const response = await fetch(url, Option);
  const data = await response.json();
  return data;
}

